import styled from 'styled-components';

const DifficultyLabel = styled.span`
  white-space: nowrap; // prevent Safari from inserting random linebreaks
`;

export default DifficultyLabel;
